/** @format */

import { END_POINT } from "utils";
import { getRequest } from "./axios";

export const activityService = {
  onGetList: async (projectId, page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.ACTIVITIES.LIST}?page=${page}&project_id=${projectId}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },

};

